import { render, staticRenderFns } from "./EarlyLearningYearsFramework.vue?vue&type=template&id=34ded781&"
import script from "./EarlyLearningYearsFramework.vue?vue&type=script&lang=js&"
export * from "./EarlyLearningYearsFramework.vue?vue&type=script&lang=js&"
import style0 from "./EarlyLearningYearsFramework.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports